/**
 * Admin Layout
 * Layout with admin navigation
 */

import { Outlet, NavLink, useNavigate } from 'react-router-dom'
import { LayoutDashboard, Package, Clock, LogOut, Shield } from 'lucide-react'
import { useAppStore } from '../../stores'
import { cn } from '../../utils/helpers'

// =============================================================================
// NAV ITEMS
// =============================================================================

const navItems = [
  { to: '/admin', icon: LayoutDashboard, label: 'Dashboard', end: true },
  { to: '/admin/deliveries', icon: Package, label: 'Deliveries' },
  { to: '/admin/clock', icon: Clock, label: 'Clock' },
]

// =============================================================================
// COMPONENT
// =============================================================================

export function AdminLayout() {
  const { user, logout } = useAppStore()
  const navigate = useNavigate()
  
  const handleLogout = () => {
    logout()
    navigate('/login')
  }
  
  return (
    <div className="min-h-screen bg-gray-50 pb-20">
      {/* Header */}
      <header className="bg-gray-900 text-white sticky top-0 z-40">
        <div className="max-w-4xl mx-auto px-4 h-14 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center">
              <Shield className="w-4 h-4 text-gray-900" />
            </div>
            <span className="font-medium">SPT Admin</span>
          </div>
          
          <div className="flex items-center gap-3">
            <span className="text-sm text-gray-300">{user?.name}</span>
            <button
              onClick={handleLogout}
              className="p-2 text-gray-400 hover:text-white hover:bg-gray-800 rounded-lg transition-colors"
              title="Logout"
            >
              <LogOut className="w-4 h-4" />
            </button>
          </div>
        </div>
      </header>
      
      {/* Main Content */}
      <main className="max-w-4xl mx-auto px-4 py-6">
        <Outlet />
      </main>
      
      {/* Bottom Navigation */}
      <nav className="fixed bottom-0 left-0 right-0 bg-gray-900 z-40">
        <div className="max-w-4xl mx-auto">
          <div className="flex">
            {navItems.map(({ to, icon: Icon, label, end }) => (
              <NavLink
                key={to}
                to={to}
                end={end}
                className={({ isActive }) =>
                  cn(
                    'flex-1 flex flex-col items-center justify-center py-3 transition-colors',
                    isActive
                      ? 'text-white'
                      : 'text-gray-500 hover:text-gray-300'
                  )
                }
              >
                <Icon className="w-5 h-5" />
                <span className="text-xs mt-1">{label}</span>
              </NavLink>
            ))}
          </div>
        </div>
      </nav>
    </div>
  )
}
